import {FormControl, InputLabel, Select, Skeleton} from "@mui/material";
import {useTranslation} from "react-i18next";
import {FC} from "react";
import {RootState, useAppSelector} from "../../../store";
import MenuItem from "@mui/material/MenuItem";
import useCitiesByCountry, {ValidCountries} from "../../../util/hooks/useCitiesByCountry";

interface Props {
    selectedCity: string
    handleChangeCity: (id: string) => void
}

const CitySelect: FC<Props> = (props) => {
    const {t, i18n} = useTranslation()
    const cities = useAppSelector((state: RootState) => state.wishReducer.citiesWithCounts)
    const citiesLoading = useAppSelector((state: RootState) => state.wishReducer.citiesWithCountsLoading)
    const {cities: citiesConst} = useCitiesByCountry(ValidCountries.MACEDONIA)

    return (
        !citiesLoading && cities.length ? <FormControl fullWidth size="small">
            <InputLabel id="wish_cities">{t('city')}</InputLabel>
            <Select
                labelId="wish_cities"
                id="wish_cities"
                color="primary"
                value={props.selectedCity}
                label={t('city')}
                onChange={(e) =>
                    props.handleChangeCity(e.target.value)}
            >
                {cities.map((city) => (
                    <MenuItem value={city.id}
                        // @ts-ignore
                              key={city.id}>{`${city.id === "all" ? t("all_cities") : citiesConst[city.city]?.[i18n.language] ?? citiesConst["Skopje"][i18n.language]} (${city.count})`}</MenuItem>
                ))}
            </Select>
        </FormControl> : <Skeleton animation='wave' variant='rectangular' height={50} width="100%"/>
    )
}

export default CitySelect
